import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "sm-search-row" }
const _hoisted_2 = { class: "sm-list" }
const _hoisted_3 = {
  key: 0,
  class: "sm-state"
}
const _hoisted_4 = {
  key: 1,
  class: "sm-state"
}
const _hoisted_5 = ["disabled", "onMouseenter", "onClick"]
const _hoisted_6 = { class: "sm-avatar" }
const _hoisted_7 = ["src", "onError"]
const _hoisted_8 = { class: "sm-agent-body" }
const _hoisted_9 = { class: "sm-agent-name" }
const _hoisted_10 = { class: "sm-agent-sub" }
const _hoisted_11 = {
  key: 0,
  class: "sm-error"
}
const _hoisted_12 = { class: "sm-head sm-head--watch" }
const _hoisted_13 = { class: "sm-head-text" }
const _hoisted_14 = { class: "sm-actions" }
const _hoisted_15 = {
  class: "sm-tools",
  role: "toolbar",
  "aria-label": "Marcar a tela do agente"
}
const _hoisted_16 = ["disabled", "title", "aria-pressed", "onClick"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["aria-pressed", "onClick"]
const _hoisted_19 = ["disabled"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "sm-board" }
const _hoisted_23 = ["maxlength", "onKeydown"]
const _hoisted_24 = {
  key: 0,
  class: "sm-marks-notice"
}
const _hoisted_25 = {
  key: 1,
  class: "sm-stage-msg"
}
const _hoisted_26 = {
  key: 2,
  class: "sm-stage-banner"
}
const _hoisted_27 = {
  key: 0,
  class: "sm-error sm-error--watch"
}

import { ref, reactive, computed, watch, nextTick, onMounted, onUnmounted } from 'vue'
import { toMediaUrl } from '@/utils/media'
import { useStore } from 'vuex'
import { Replayer, EventType, type eventWithTime } from 'rrweb'
import 'rrweb/dist/style.css'
import html2canvas from 'html2canvas'
import { listAgents, type CpAgent } from '@/services/wootdashAgents'
import { invokeHub, onHubEvent } from '@/composables/useConversationRealtime'
import { screenMirrorOpen, unpackMirrorEvents } from '@/composables/useScreenMirror'
import { MarkBoard, drawMarks, fitCanvas, newMarkId, MARK_COLORS, MAX_TEXT_LENGTH, type MarkMessage, type Point } from '@/utils/mirrorMarks'

type LiveState = 'waiting' | 'live' | 'hidden' | 'ended'
interface StartResult { success: boolean; failure: number | string; sessionId: string | null; agentName: string | null }
interface MirrorChunk { sessionId: string; agentId: string; tabId: string; seq: number; index: number; total: number; chunk: string }
interface MirrorState { sessionId: string; agentId: string; tabId: string; state: 'visivel' | 'oculta' | 'encerrado' | 'marcacoes_limpas' | 'marcacoes_ocultas' | 'marcacoes_visiveis' }

type Tool = 'none' | 'pen' | 'arrow' | 'text' | 'pointer'
const SEND_EVERY_MS = 50


export default /*@__PURE__*/_defineComponent({
  __name: 'ScreenMirrorModal',
  setup(__props) {

// Espelho ao vivo (Ctrl+@) — lado do SUPERVISOR. Escolhe o agente, pede a sessão pelo hub (IniciarEspelho: checa a
// permissão agents.screen_view e grava na auditoria) e toca ao vivo, com o Replayer do rrweb, os quadros que a aba do
// agente manda (useScreenMirror.ts). ManterEspelho a cada 10 s mantém a sessão viva — sem ele a aba do agente para.
const STATE_LABEL: Record<LiveState, string> = {
  waiting: 'Esperando a tela',
  live: 'Ao vivo',
  hidden: 'Fora da aba do sistema',
  ended: 'Saiu do sistema',
}
const FAILURE_LABEL: Record<string, string> = {
  Forbidden: 'Seu perfil não tem a permissão "Ver tela de agente". Peça a um administrador em Perfis.',
  AgentNotFound: 'Agente não encontrado ou inativo.',
  Self: 'Escolha outro agente — esta é a sua própria tela.',
}
const FAILURE_BY_NUMBER = ['None', 'Forbidden', 'AgentNotFound', 'Self']

const store = useStore()
const token = computed<string>(() => store.getters.authUser?.wootdash_token ?? '')
const myId = computed<string>(() => (store.getters.authUser?.wootdash_agent_id ?? '').toLowerCase())

const step = ref<'pick' | 'watch'>('pick')
const agents = ref<CpAgent[]>([])
const loadingAgents = ref(false)
const query = ref('')
const focused = ref(0)
const error = ref('')
const starting = ref(false)
const searchRef = ref<HTMLInputElement | null>(null)

const target = ref<CpAgent | null>(null)
const sessionId = ref<string | null>(null)
const liveState = ref<LiveState>('waiting')
const lastActivity = ref<number | null>(null)
const nowTick = ref(Date.now())
const hasPlayer = ref(false)
const printing = ref(false)
const stageRef = ref<HTMLElement | null>(null)
const playerRoot = ref<HTMLElement | null>(null)

let replayer: Replayer | null = null
let currentTab: string | null = null
let offset = 0
let viewport = { width: 0, height: 0 }
const pending = new Map<string, { parts: (string | undefined)[]; got: number }>()
let keepAliveTimer: ReturnType<typeof setInterval> | undefined
let tickTimer: ReturnType<typeof setInterval> | undefined
let firstFrameTimer: ReturnType<typeof setTimeout> | undefined
let resizeObserver: ResizeObserver | undefined

const fullName = (a: CpAgent) => `${a.firstName} ${a.lastName ?? ''}`.trim()
// avatarUrl vem cru da API (caminho relativo de POST /anexos) — toMediaUrl monta a URL exibível. Foto que não
// carrega cai pras iniciais.
const brokenAvatars = reactive(new Set<string>())
const avatarSrc = (a: CpAgent): string | null => (brokenAvatars.has(a.id) ? null : toMediaUrl(a.avatarUrl))
const initials = (a: CpAgent) => `${a.firstName?.[0] ?? ''}${a.lastName?.[0] ?? ''}`.toUpperCase() || '?'
const isOnline = (a: CpAgent) => (a.status ?? '').toLowerCase() === 'online'

const filtered = computed(() => {
  const q = query.value.trim().toLowerCase()
  return agents.value
    .filter(a => a.isActive && a.id.toLowerCase() !== myId.value)
    .filter(a => !q || fullName(a).toLowerCase().includes(q) || (a.email ?? '').toLowerCase().includes(q))
    .sort((a, b) => Number(isOnline(b)) - Number(isOnline(a)) || fullName(a).localeCompare(fullName(b), 'pt-BR'))
})
watch(query, () => { focused.value = 0 })

const activityLabel = computed(() => {
  if (!lastActivity.value) return ''
  const s = Math.max(0, Math.round((nowTick.value - lastActivity.value) / 1000))
  return s < 3 ? 'atividade agora' : s < 60 ? `atividade há ${s}s` : `atividade há ${Math.round(s / 60)} min`
})

function moveFocus(delta: number) {
  const n = filtered.value.length
  if (n) focused.value = (focused.value + delta + n) % n
}

async function loadAgents() {
  loadingAgents.value = true
  try {
    agents.value = (await listAgents(token.value)).agents
  } catch {
    error.value = 'Não deu pra carregar os agentes.'
  } finally {
    loadingAgents.value = false
  }
}

watch(screenMirrorOpen, async open => {
  if (open) {
    step.value = 'pick'
    error.value = ''
    query.value = ''
    await nextTick()
    searchRef.value?.focus()
    await loadAgents()
  } else {
    await stop()
  }
})

// ── sessão ──────────────────────────────────────────────────────────────────────────────────

function failureText(failure: number | string): string {
  const key = typeof failure === 'number' ? FAILURE_BY_NUMBER[failure] : failure
  return FAILURE_LABEL[key ?? ''] ?? 'Não deu pra iniciar o espelho.'
}

async function start(agent: CpAgent) {
  if (starting.value) return
  starting.value = true
  error.value = ''
  try {
    const result = await invokeHub<StartResult>('IniciarEspelho', agent.id)
    if (!result.success || !result.sessionId) {
      error.value = failureText(result.failure)
      return
    }
    target.value = agent
    sessionId.value = result.sessionId
    liveState.value = 'waiting'
    lastActivity.value = null
    step.value = 'watch'
    keepAliveTimer = setInterval(() => ping(false), 10_000)
    tickTimer = setInterval(() => { nowTick.value = Date.now() }, 1_000)
    // A aba do agente não respondeu (recarregando, ou o "iniciar" se perdeu): pede a foto inteira de novo.
    firstFrameTimer = setTimeout(() => { if (!replayer) ping(true) }, 4_000)
    await nextTick()
    if (stageRef.value) {
      resizeObserver = new ResizeObserver(() => fit())
      resizeObserver.observe(stageRef.value)
    }
  } catch (e: any) {
    error.value = e?.message || 'Não deu pra iniciar o espelho.'
  } finally {
    starting.value = false
  }
}

function ping(fullSnapshot: boolean) {
  if (!target.value || !sessionId.value) return
  invokeHub('ManterEspelho', target.value.id, sessionId.value, fullSnapshot).catch(() => { /* reconecta e tenta no próximo */ })
}

async function stop() {
  resetMarks()
  if (keepAliveTimer) clearInterval(keepAliveTimer)
  if (tickTimer) clearInterval(tickTimer)
  if (firstFrameTimer) clearTimeout(firstFrameTimer)
  keepAliveTimer = tickTimer = firstFrameTimer = undefined
  resizeObserver?.disconnect()
  resizeObserver = undefined
  if (target.value && sessionId.value) {
    await invokeHub('PararEspelho', target.value.id, sessionId.value).catch(() => { /* a aba do agente para sozinha em 30 s */ })
  }
  destroyPlayer()
  pending.clear()
  sessionId.value = null
  target.value = null
  liveState.value = 'waiting'
  lastActivity.value = null
}

async function switchAgent() {
  await stop()
  error.value = ''
  step.value = 'pick'
  await nextTick()
  searchRef.value?.focus()
  await loadAgents()
}

function close() {
  if (document.fullscreenElement) void document.exitFullscreen()
  screenMirrorOpen.value = false
}

// ── quadros ─────────────────────────────────────────────────────────────────────────────────

function onChunk(c: MirrorChunk) {
  if (c.sessionId !== sessionId.value || c.agentId.toLowerCase() !== target.value?.id.toLowerCase()) return
  const key = `${c.tabId}:${c.seq}`
  const batch = pending.get(key) ?? { parts: new Array(c.total), got: 0 }
  if (batch.parts[c.index] === undefined) {
    batch.parts[c.index] = c.chunk
    batch.got++
  }
  pending.set(key, batch)
  if (batch.got < batch.parts.length) {
    if (pending.size > 300) pending.delete(pending.keys().next().value!) // lote que nunca completou
    return
  }
  pending.delete(key)
  unpackMirrorEvents(batch.parts.join('')).then(events => apply(c.tabId, events)).catch(() => { /* lote corrompido: o próximo checkout corrige */ })
}

function onState(s: MirrorState) {
  if (s.sessionId !== sessionId.value) return
  if (s.state === 'marcacoes_limpas') {
    board.apply({ op: 'clear' })
    myMarks.value = []
    showMarksNotice('As marcações sumiram: o agente trocou de página ou redimensionou a janela.')
    schedulePaint()
    return
  }
  if (s.state === 'marcacoes_ocultas' || s.state === 'marcacoes_visiveis') {
    agentHidMarks.value = s.state === 'marcacoes_ocultas'
    return
  }
  if (s.state === 'oculta') liveState.value = 'hidden'
  else if (s.state === 'encerrado') liveState.value = 'ended'
  else liveState.value = replayer ? 'live' : 'waiting'
}

function apply(tab: string, events: eventWithTime[]) {
  for (const e of events) {
    // Meta abre toda foto inteira (início da gravação, aba que voltou, "Atualizar"): recomeça o player nela.
    if (e.type === EventType.Meta) {
      createPlayer(e, tab)
      continue
    }
    if (!replayer || tab !== currentTab) continue
    replayer.addEvent({ ...e, timestamp: e.timestamp + offset } as eventWithTime)
  }
  if (!replayer) return
  lastActivity.value = Date.now()
  if (liveState.value === 'waiting' || liveState.value === 'ended') liveState.value = 'live'
}

function createPlayer(meta: eventWithTime, tab: string) {
  destroyPlayer()
  if (!playerRoot.value) return
  // Relógio do agente ≠ relógio daqui: alinha pelo momento em que a foto chegou.
  offset = Date.now() - meta.timestamp
  currentTab = tab
  const data = meta.data as { width?: number; height?: number }
  viewport = { width: data.width ?? 1280, height: data.height ?? 720 }
  replayer = new Replayer([], {
    root: playerRoot.value,
    liveMode: true,
    mouseTail: false,
    showWarning: false,
    triggerFocus: false,
    UNSAFE_replayCanvas: false,
  })
  replayer.on('resize', (d: any) => {
    if (d?.width && d?.height) viewport = { width: d.width, height: d.height }
    fit()
  })
  replayer.startLive(Date.now() - 300)
  replayer.addEvent({ ...meta, timestamp: meta.timestamp + offset } as eventWithTime)
  hasPlayer.value = true
  if (liveState.value !== 'hidden') liveState.value = 'live'
  void nextTick(fit)
}

function destroyPlayer() {
  try { replayer?.destroy() } catch { /* já destruído */ }
  replayer = null
  currentTab = null
  hasPlayer.value = false
  if (playerRoot.value) playerRoot.value.innerHTML = ''
}

/** A tela do agente tem o tamanho da janela dele: encolhe (ou amplia até 1,5x) pra caber no palco. */
function fit() {
  const stage = stageRef.value
  const root = playerRoot.value
  const wrapper = root?.querySelector<HTMLElement>('.replayer-wrapper')
  if (!stage || !root || !wrapper || !viewport.width || !viewport.height) return
  const scale = Math.min(stage.clientWidth / viewport.width, stage.clientHeight / viewport.height, 1.5)
  wrapper.style.transform = `scale(${scale})`
  wrapper.style.transformOrigin = 'top left'
  root.style.width = `${Math.floor(viewport.width * scale)}px`
  root.style.height = `${Math.floor(viewport.height * scale)}px`
  schedulePaint()
}

// ── print e tela cheia ──────────────────────────────────────────────────────────────────────

async function takePrint() {
  const doc = playerRoot.value?.querySelector('iframe')?.contentDocument
  if (!doc?.documentElement || printing.value) return
  printing.value = true
  error.value = ''
  try {
    const canvas = await html2canvas(doc.documentElement, {
      width: viewport.width,
      height: viewport.height,
      windowWidth: viewport.width,
      windowHeight: viewport.height,
      useCORS: true,
      logging: false,
      backgroundColor: '#ffffff',
    })
    const stamp = new Date().toLocaleString('pt-BR').replace(/[/:]/g, '-').replace(', ', '_')
    const link = document.createElement('a')
    link.href = canvas.toDataURL('image/png')
    link.download = `tela-${(target.value ? fullName(target.value) : 'agente').replace(/\s+/g, '-').toLowerCase()}-${stamp}.png`
    link.click()
  } catch {
    error.value = 'Não deu pra gerar o print desta tela. Use Win+Shift+S enquanto isso.'
  } finally {
    printing.value = false
  }
}

function toggleFullscreen() {
  if (document.fullscreenElement) void document.exitFullscreen()
  else void stageRef.value?.requestFullscreen?.()
}

// ── marcações (lápis, seta, texto, ponteiro) ─────────────────────────────────────────────────
// O que você marca vai pro hub (MarcarEspelho) e aparece por cima da tela do agente; aqui o mesmo quadro desenha
// por cima da imagem. Posições em proporção da tela dele (0 a 1). Lápis/seta somem em 10 s; texto fica até limpar.

const TOOLS: { id: Exclude<Tool, 'none'>; title: string; icon: string }[] = [
  { id: 'pen', title: 'Lápis — desenha na tela do agente (some em 10 s)', icon: '<path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"/>' },
  { id: 'arrow', title: 'Seta — arraste do ponto inicial até onde apontar (some em 10 s)', icon: '<line x1="5" y1="19" x2="19" y2="5"/><polyline points="9 5 19 5 19 15"/>' },
  { id: 'text', title: 'Texto — clique onde quer o recado (fica até limpar)', icon: '<polyline points="4 7 4 4 20 4 20 7"/><line x1="9" y1="20" x2="15" y2="20"/><line x1="12" y1="4" x2="12" y2="20"/>' },
  { id: 'pointer', title: 'Apontar — o agente vê um ponto seguindo o seu mouse', icon: '<circle cx="12" cy="12" r="3"/><circle cx="12" cy="12" r="8" stroke-dasharray="3 3"/>' },
]
const tool = ref<Tool>('none')
const color = ref<string>(MARK_COLORS[0])
const markCanvas = ref<HTMLCanvasElement | null>(null)
const textInput = ref<HTMLTextAreaElement | null>(null)
const myMarks = ref<string[]>([])
const agentHidMarks = ref(false)
const marksNotice = ref('')
const textDraft = ref<{ x: number; y: number; left: number; top: number; value: string } | null>(null)
const board = new MarkBoard()
let paintFrame = 0
let annotated = false
let drawing: { id: string; kind: 'stroke' | 'arrow'; start: Point } | null = null
let pendingPoints: Point[] = []
let sendTimer: ReturnType<typeof setInterval> | undefined
let lastPointerSent = 0
let noticeTimer: ReturnType<typeof setTimeout> | undefined

function pickTool(t: Tool) {
  tool.value = tool.value === t ? 'none' : t
  textDraft.value = null
}

function showMarksNotice(text: string) {
  marksNotice.value = text
  if (noticeTimer) clearTimeout(noticeTimer)
  noticeTimer = setTimeout(() => { marksNotice.value = '' }, 5_000)
}

function paintMarks() {
  paintFrame = 0
  const canvas = markCanvas.value
  if (!canvas || !canvas.clientWidth) return
  const animating = board.prune()
  const ctx = fitCanvas(canvas, canvas.clientWidth, canvas.clientHeight)
  if (ctx) drawMarks(ctx, canvas.clientWidth, canvas.clientHeight, board)
  if (animating) paintFrame = requestAnimationFrame(paintMarks)
}

function schedulePaint() {
  if (!paintFrame) paintFrame = requestAnimationFrame(paintMarks)
}

/** Aplica aqui e manda pro agente. A 1ª marcação da sessão fica registrada na auditoria (só que houve). */
function sendMark(msg: MarkMessage) {
  if (!target.value || !sessionId.value) return
  board.apply(msg)
  schedulePaint()
  if (!annotated) {
    annotated = true
    invokeHub('RegistrarMarcacaoEspelho', target.value.id, sessionId.value).catch(() => { /* só auditoria */ })
  }
  invokeHub('MarcarEspelho', target.value.id, sessionId.value, JSON.stringify(msg)).catch(() => { /* reconecta e segue */ })
}

function flushPoints(done = false) {
  if (!drawing || drawing.kind !== 'stroke') return
  if (!pendingPoints.length && !done) return
  const points = pendingPoints
  pendingPoints = []
  if (!target.value || !sessionId.value) return
  const msg: MarkMessage = { op: 'append', id: drawing.id, points, done }
  invokeHub('MarcarEspelho', target.value.id, sessionId.value, JSON.stringify(msg)).catch(() => { /* segue */ })
}

function at(e: PointerEvent): Point {
  const rect = markCanvas.value!.getBoundingClientRect()
  return [Math.min(1, Math.max(0, (e.clientX - rect.left) / rect.width)), Math.min(1, Math.max(0, (e.clientY - rect.top) / rect.height))]
}

function onMarkDown(e: PointerEvent) {
  if (!hasPlayer.value || tool.value === 'none' || tool.value === 'pointer') return
  const p = at(e)
  if (tool.value === 'text') {
    e.preventDefault()
    const rect = markCanvas.value!.getBoundingClientRect()
    textDraft.value = { x: p[0], y: p[1], left: p[0] * rect.width, top: p[1] * rect.height, value: '' }
    void nextTick(() => textInput.value?.focus())
    return
  }
  markCanvas.value!.setPointerCapture(e.pointerId)
  const id = newMarkId()
  drawing = { id, kind: tool.value === 'pen' ? 'stroke' : 'arrow', start: p }
  if (drawing.kind === 'stroke') {
    sendMark({ op: 'add', mark: { id, kind: 'stroke', color: color.value, width: 4, points: [p], done: false } })
    myMarks.value = [...myMarks.value, id]
    sendTimer = setInterval(() => flushPoints(), SEND_EVERY_MS)
  } else {
    // Seta: prévia só aqui; vai pro agente pronta, no soltar.
    board.apply({ op: 'add', mark: { id, kind: 'arrow', color: color.value, width: 4, points: [p, p], done: false } })
    schedulePaint()
  }
}

function onMarkMove(e: PointerEvent) {
  if (tool.value === 'pointer' && hasPlayer.value) {
    const now = Date.now()
    if (now - lastPointerSent < SEND_EVERY_MS) return
    lastPointerSent = now
    const [x, y] = at(e)
    sendMark({ op: 'pointer', x, y, color: color.value })
    return
  }
  if (!drawing) return
  const p = at(e)
  if (drawing.kind === 'stroke') {
    board.apply({ op: 'append', id: drawing.id, points: [p] })
    pendingPoints.push(p)
  } else {
    const m = board.marks.get(drawing.id)
    if (m) m.points = [drawing.start, p]
  }
  schedulePaint()
}

function onMarkUp(e: PointerEvent) {
  if (!drawing) return
  const d = drawing
  if (d.kind === 'stroke') {
    if (sendTimer) clearInterval(sendTimer)
    sendTimer = undefined
    flushPoints(true)
    board.apply({ op: 'append', id: d.id, points: [], done: true })
  } else {
    const end = at(e)
    board.apply({ op: 'undo', id: d.id })
    // Clique sem arrastar não vira seta.
    if (Math.hypot(end[0] - d.start[0], end[1] - d.start[1]) > 0.01) {
      sendMark({ op: 'add', mark: { id: d.id, kind: 'arrow', color: color.value, width: 4, points: [d.start, end], done: true } })
      myMarks.value = [...myMarks.value, d.id]
    }
  }
  drawing = null
  schedulePaint()
}

function onMarkLeave(e: PointerEvent) {
  if (drawing && !markCanvas.value?.hasPointerCapture(e.pointerId)) onMarkUp(e)
}

function commitText() {
  const draft = textDraft.value
  textDraft.value = null
  const text = draft?.value.trim()
  if (!draft || !text) return
  const id = newMarkId()
  sendMark({ op: 'add', mark: { id, kind: 'text', color: color.value, width: 4, points: [[draft.x, draft.y]], text, done: true } })
  myMarks.value = [...myMarks.value, id]
}

function undoMark() {
  const id = myMarks.value[myMarks.value.length - 1]
  if (!id) return
  myMarks.value = myMarks.value.slice(0, -1)
  sendMark({ op: 'undo', id })
}

function clearMarks() {
  myMarks.value = []
  sendMark({ op: 'clear' })
}

/** Fim da sessão (parar, trocar de agente): zera tudo daqui. */
function resetMarks() {
  if (sendTimer) clearInterval(sendTimer)
  sendTimer = undefined
  drawing = null
  pendingPoints = []
  board.apply({ op: 'clear' })
  myMarks.value = []
  annotated = false
  agentHidMarks.value = false
  marksNotice.value = ''
  textDraft.value = null
  tool.value = 'none'
  schedulePaint()
}

function onKeydown(e: KeyboardEvent) {
  if (screenMirrorOpen.value && e.key === 'Escape' && !document.fullscreenElement) {
    if (textDraft.value) { textDraft.value = null; return }
    if (tool.value !== 'none') { tool.value = 'none'; return }
    close()
  }
}

const offs: (() => void)[] = []
onMounted(() => {
  offs.push(onHubEvent('QuadrosEspelho', onChunk), onHubEvent('EstadoEspelho', onState))
  window.addEventListener('keydown', onKeydown)
})
onUnmounted(() => {
  offs.forEach(off => off())
  window.removeEventListener('keydown', onKeydown)
  void stop()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "sm-fade" }, {
      default: _withCtx(() => [
        (_unref(screenMirrorOpen))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "sm-overlay",
              onMousedown: _withModifiers(close, ["self"])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["sm-box", { 'sm-box--watch': step.value === 'watch' }]),
                role: "dialog",
                "aria-label": "Espelho ao vivo"
              }, [
                (step.value === 'pick')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", { class: "sm-head" }, [
                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "sm-head-icon" }, [
                          _createElementVNode("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("rect", {
                              x: "2",
                              y: "3",
                              width: "20",
                              height: "14",
                              rx: "2"
                            }),
                            _createElementVNode("path", { d: "M8 21h8M12 17v4" }),
                            _createElementVNode("circle", {
                              cx: "12",
                              cy: "10",
                              r: "2.5"
                            })
                          ])
                        ], -1)),
                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "sm-head-text" }, [
                          _createElementVNode("strong", null, "Espelho ao vivo"),
                          _createElementVNode("span", null, "Veja ao vivo a tela do sistema de um agente")
                        ], -1)),
                        _cache[10] || (_cache[10] = _createElementVNode("kbd", { class: "sm-kbd" }, "Ctrl @", -1)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "sm-icon-btn",
                          title: "Fechar (Esc)",
                          onClick: close
                        }, [...(_cache[7] || (_cache[7] = [
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round"
                          }, [
                            _createElementVNode("line", {
                              x1: "18",
                              y1: "6",
                              x2: "6",
                              y2: "18"
                            }),
                            _createElementVNode("line", {
                              x1: "6",
                              y1: "6",
                              x2: "18",
                              y2: "18"
                            })
                          ], -1)
                        ]))])
                      ]),
                      _createElementVNode("div", _hoisted_1, [
                        _cache[11] || (_cache[11] = _createElementVNode("svg", {
                          width: "15",
                          height: "15",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }, [
                          _createElementVNode("circle", {
                            cx: "11",
                            cy: "11",
                            r: "8"
                          }),
                          _createElementVNode("line", {
                            x1: "21",
                            y1: "21",
                            x2: "16.65",
                            y2: "16.65"
                          })
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          ref_key: "searchRef",
                          ref: searchRef,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((query).value = $event)),
                          class: "sm-search",
                          placeholder: "Buscar agente pelo nome ou e-mail...",
                          autocomplete: "off",
                          spellcheck: "false",
                          onKeydown: [
                            _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (moveFocus(1)), ["prevent"]), ["down"])),
                            _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (moveFocus(-1)), ["prevent"]), ["up"])),
                            _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (filtered.value[focused.value] && start(filtered.value[focused.value])), ["prevent"]), ["enter"]))
                          ]
                        }, null, 544), [
                          [_vModelText, query.value]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_2, [
                        (loadingAgents.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[12] || (_cache[12] = [
                              _createElementVNode("span", { class: "sm-spinner" }, null, -1),
                              _createTextVNode(" Carregando agentes...", -1)
                            ]))]))
                          : (!filtered.value.length)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Nenhum agente encontrado."))
                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filtered.value, (a, i) => {
                                return (_openBlock(), _createElementBlock("button", {
                                  key: a.id,
                                  type: "button",
                                  class: _normalizeClass(["sm-agent", { 'sm-agent--focus': focused.value === i }]),
                                  disabled: starting.value,
                                  onMouseenter: ($event: any) => (focused.value = i),
                                  onClick: ($event: any) => (start(a))
                                }, [
                                  _createElementVNode("span", _hoisted_6, [
                                    (avatarSrc(a))
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          src: avatarSrc(a)!,
                                          alt: "",
                                          onError: ($event: any) => (brokenAvatars.add(a.id))
                                        }, null, 40, _hoisted_7))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(initials(a)), 1)
                                        ], 64)),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["sm-dot", isOnline(a) ? 'sm-dot--on' : 'sm-dot--off'])
                                    }, null, 2)
                                  ]),
                                  _createElementVNode("span", _hoisted_8, [
                                    _createElementVNode("span", _hoisted_9, _toDisplayString(fullName(a)), 1),
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(a.email), 1)
                                  ]),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["sm-agent-status", { 'sm-agent-status--on': isOnline(a) }])
                                  }, _toDisplayString(isOnline(a) ? 'Online' : 'Offline'), 3)
                                ], 42, _hoisted_5))
                              }), 128))
                      ]),
                      (error.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(error.value), 1))
                        : _createCommentVNode("", true),
                      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "sm-foot" }, " Só a aba do WootDash é mostrada, nunca outras janelas. O agente vê um aviso enquanto você assiste, e a sessão fica registrada na auditoria. ", -1))
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "sm-back",
                          title: "Trocar agente",
                          onClick: switchAgent
                        }, [...(_cache[14] || (_cache[14] = [
                          _createElementVNode("svg", {
                            width: "14",
                            height: "14",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "2.5",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          }, [
                            _createElementVNode("polyline", { points: "15 18 9 12 15 6" })
                          ], -1),
                          _createTextVNode(" Trocar ", -1)
                        ]))]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("strong", null, _toDisplayString(target.value ? fullName(target.value) : ''), 1),
                          _createElementVNode("span", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["sm-live", 'sm-live--' + liveState.value])
                            }, _toDisplayString(STATE_LABEL[liveState.value]), 3),
                            (activityLabel.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(" · " + _toDisplayString(activityLabel.value), 1)
                                ], 64))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(TOOLS, (t) => {
                              return _createElementVNode("button", {
                                key: t.id,
                                type: "button",
                                class: _normalizeClass(["sm-tool", { 'is-on': tool.value === t.id }]),
                                disabled: !hasPlayer.value,
                                title: t.title,
                                "aria-pressed": tool.value === t.id,
                                onClick: ($event: any) => (pickTool(t.id))
                              }, [
                                (_openBlock(), _createElementBlock("svg", {
                                  width: "14",
                                  height: "14",
                                  viewBox: "0 0 24 24",
                                  fill: "none",
                                  stroke: "currentColor",
                                  "stroke-width": "2.2",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  innerHTML: t.icon
                                }, null, 8, _hoisted_17))
                              ], 10, _hoisted_16)
                            }), 64)),
                            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "sm-tools-sep" }, null, -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MARK_COLORS), (c) => {
                              return (_openBlock(), _createElementBlock("button", {
                                key: c,
                                type: "button",
                                class: _normalizeClass(["sm-color", { 'is-on': color.value === c }]),
                                style: _normalizeStyle({ background: c }),
                                title: 'Cor',
                                "aria-pressed": color.value === c,
                                onClick: ($event: any) => (color.value = c)
                              }, null, 14, _hoisted_18))
                            }), 128)),
                            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "sm-tools-sep" }, null, -1)),
                            _createElementVNode("button", {
                              type: "button",
                              class: "sm-tool",
                              disabled: !myMarks.value.length,
                              title: "Desfazer a última marcação",
                              onClick: undoMark
                            }, [...(_cache[15] || (_cache[15] = [
                              _createElementVNode("svg", {
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M3 7v6h6" }),
                                _createElementVNode("path", { d: "M21 17a9 9 0 0 0-15-6.7L3 13" })
                              ], -1)
                            ]))], 8, _hoisted_19),
                            _createElementVNode("button", {
                              type: "button",
                              class: "sm-tool",
                              disabled: !hasPlayer.value,
                              title: "Limpar todas as marcações",
                              onClick: clearMarks
                            }, [...(_cache[16] || (_cache[16] = [
                              _createElementVNode("svg", {
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                "stroke-width": "2.2",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round"
                              }, [
                                _createElementVNode("path", { d: "M3 6h18" }),
                                _createElementVNode("path", { d: "M8 6V4h8v2" }),
                                _createElementVNode("path", { d: "M19 6l-1 14H6L5 6" })
                              ], -1)
                            ]))], 8, _hoisted_20)
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "sm-btn",
                            title: "Pedir a tela inteira de novo",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (ping(true)))
                          }, [...(_cache[19] || (_cache[19] = [
                            _createElementVNode("svg", {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("polyline", { points: "23 4 23 10 17 10" }),
                              _createElementVNode("path", { d: "M20.49 15a9 9 0 1 1-2.12-9.36L23 10" })
                            ], -1),
                            _createTextVNode(" Atualizar ", -1)
                          ]))]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "sm-btn",
                            disabled: !hasPlayer.value || printing.value,
                            title: "Baixar uma imagem da tela agora",
                            onClick: takePrint
                          }, [
                            _cache[20] || (_cache[20] = _createElementVNode("svg", {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z" }),
                              _createElementVNode("circle", {
                                cx: "12",
                                cy: "13",
                                r: "4"
                              })
                            ], -1)),
                            _createTextVNode(" " + _toDisplayString(printing.value ? 'Gerando...' : 'Print'), 1)
                          ], 8, _hoisted_21),
                          _createElementVNode("button", {
                            type: "button",
                            class: "sm-btn",
                            title: "Tela cheia",
                            onClick: toggleFullscreen
                          }, [...(_cache[21] || (_cache[21] = [
                            _createElementVNode("svg", {
                              width: "14",
                              height: "14",
                              viewBox: "0 0 24 24",
                              fill: "none",
                              stroke: "currentColor",
                              "stroke-width": "2.2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            }, [
                              _createElementVNode("path", { d: "M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" })
                            ], -1)
                          ]))]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "sm-btn sm-btn--stop",
                            title: "Parar e fechar (Esc)",
                            onClick: close
                          }, "Parar")
                        ])
                      ]),
                      _createElementVNode("div", {
                        ref_key: "stageRef",
                        ref: stageRef,
                        class: "sm-stage"
                      }, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", {
                            ref_key: "playerRoot",
                            ref: playerRoot,
                            class: "sm-player"
                          }, null, 512),
                          _withDirectives(_createElementVNode("canvas", {
                            ref_key: "markCanvas",
                            ref: markCanvas,
                            class: _normalizeClass(["sm-marks", ['sm-marks--' + tool.value]]),
                            onPointerdown: onMarkDown,
                            onPointermove: onMarkMove,
                            onPointerup: onMarkUp,
                            onPointercancel: onMarkUp,
                            onPointerleave: onMarkLeave
                          }, null, 34), [
                            [_vShow, hasPlayer.value]
                          ]),
                          (textDraft.value)
                            ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
                                key: 0,
                                ref_key: "textInput",
                                ref: textInput,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((textDraft.value.value) = $event)),
                                class: "sm-text-input",
                                maxlength: _unref(MAX_TEXT_LENGTH),
                                rows: "2",
                                style: _normalizeStyle({ left: textDraft.value.left + 'px', top: textDraft.value.top + 'px', borderColor: color.value }),
                                placeholder: "Escreva e tecle Enter",
                                onKeydown: [
                                  _withKeys(_withModifiers(commitText, ["exact","prevent"]), ["enter"]),
                                  _cache[6] || (_cache[6] = _withKeys(_withModifiers(($event: any) => (textDraft.value = null), ["stop","prevent"]), ["esc"]))
                                ],
                                onBlur: commitText
                              }, null, 44, _hoisted_23)), [
                                [_vModelText, textDraft.value.value]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        (hasPlayer.value && (agentHidMarks.value || marksNotice.value))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(agentHidMarks.value ? 'O agente escondeu as marcações — ele não está vendo o que você marcar.' : marksNotice.value), 1))
                          : _createCommentVNode("", true),
                        (!hasPlayer.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                              (liveState.value === 'hidden')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[22] || (_cache[22] = _createElementVNode("strong", null, "A aba do sistema não está visível agora", -1)),
                                    _cache[23] || (_cache[23] = _createElementVNode("span", null, "Quando o agente voltar pra aba do WootDash, a tela aparece aqui.", -1))
                                  ], 64))
                                : (liveState.value === 'ended')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _cache[24] || (_cache[24] = _createElementVNode("strong", null, "O agente saiu do sistema", -1)),
                                      _cache[25] || (_cache[25] = _createElementVNode("span", null, "Escolha outro agente ou espere ele entrar de novo.", -1))
                                    ], 64))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                      _cache[26] || (_cache[26] = _createElementVNode("span", { class: "sm-spinner sm-spinner--big" }, null, -1)),
                                      _createElementVNode("strong", null, "Esperando a tela de " + _toDisplayString(target.value?.firstName) + "…", 1),
                                      _cache[27] || (_cache[27] = _createElementVNode("span", null, "Ele precisa estar com o WootDash aberto. Se estiver offline, a tela aparece assim que ele entrar.", -1))
                                    ], 64))
                            ]))
                          : (liveState.value !== 'live')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(liveState.value === 'hidden' ? 'O agente saiu da aba do sistema — mostrando a última imagem.' : 'O agente saiu do sistema — mostrando a última imagem.'), 1))
                            : _createCommentVNode("", true)
                      ], 512),
                      (error.value)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(error.value), 1))
                        : _createCommentVNode("", true)
                    ], 64))
              ], 2)
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})